
import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import { isDesktop } from '@/helpers/isDesktop';
import { ApprovalState } from '@/components/prine/enums/ApprovalState';
import { showErrorNotification } from '@/helpers/showErrorNotification';
import type { XSubProcess } from '@/models/xsubprocess';
import { xSubProcessWebservice } from '@/webservices/xsubprocess';

@Component({
    name: 'FormSubprocessPicker',
})
export default class FormSubprocessPicker extends Vue {
    @Model('input', {
        required: true,
    })
    private subprocess: XSubProcess[];

    @Prop({
        required: false,
        default: () => [],
    })
    private availableSubprocesses: XSubProcess[];

    @Prop({
        required: true,
    })
    private phaseId: number;

    @Prop({
        required: false,
        default: ApprovalState.ALL,
    })
    private approvalState: ApprovalState;

    @Prop({
        required: false,
        default: false,
    })
    private preselected: boolean;

    @Prop({
        required: false,
        default: () => false,
    })
    private subProcessIsSet: boolean;

    private disabled: boolean = false;

    private defaultSubprocesses: XSubProcess[] = [];

    private isDesktop = isDesktop();

    mounted() {
        this.loadOptions();
        // if (this.subProcessIsSet) {
        //     this.disabled = true;
        // }
    }

    loadOptions() {
        xSubProcessWebservice
            .load(this.phaseId, this.approvalState)
            .then((response) => {
                this.defaultSubprocesses = response.data;
            })
            .catch(() => {
                showErrorNotification('');
            });
    }

    get selected() {
        // Return first sub-phase in case `preselected` is true,
        // and not already selected
        if (!this.subprocess && this.preselected && this.defaultSubprocesses[0]) {
            const preselectedSubPhase = this.defaultSubprocesses[0];

            // We need to emit input because parent element
            // uses vue v-bind directive to bind input on this component
            this.$emit('input', preselectedSubPhase);

            return preselectedSubPhase;
        }

        return this.subprocess;
    }

    get available() {
        return this.availableSubprocesses.length > 0 ? this.availableSubprocesses : this.defaultSubprocesses;
    }
}
